import React, { useEffect, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useAuthRedirect from "../hooks/useAuthRedirect";
import "../css/home.css";

// ✅ point these to your actual files
import Logo from "../assets/logo.png";
import VehicleImg from "../assets/vehicle-min.jpg";
import InventoryImg from "../assets/inventory-min.jpg";

export default function Home() {
  useAuthRedirect();
  const nav = useNavigate();



  // read from localStorage (or fallbacks)
  const siteName  = localStorage.getItem("company");
  const username  = localStorage.getItem("username");
  const branch    = localStorage.getItem("branch");
  const storedMemId = localStorage.getItem("memberId");

  const moduleCode = useMemo(() => {
    const raw = localStorage.getItem("module");
    const n = parseInt(raw ?? "0", 10);
    return Number.isFinite(n) ? n : 0;
  }, []);

  console.log(moduleCode);
  

  const showVehicle = moduleCode === 1 || moduleCode === 3;
  const showInventory = moduleCode === 2 || moduleCode === 3;

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!storedMemId) return;
      try {
        const res = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/inventory_accPermission?memId=${storedMemId}`
        );
        localStorage.setItem("permissions", JSON.stringify(res.data.InventoryAccess));
      } catch (err) {
        console.error("Error fetching permissions", err);
      }
    };
    fetchPermissions();
  }, [storedMemId]);


  return (
    <div className="home-root theme-aurora"> 
      {/* Header */}
      <header className="app-header">
        <div className="header-left">
          <div className="brand" data-sub="Dashboard">{siteName}</div>
          <div className="brand-sub">Dashboard</div>
          {/* <img src={Logo} alt="Company logo" className="logo-mark" /> */}
        </div>

        <div className="header-center">
          
        </div>

        <div className="header-right user-info" aria-label="User details">
          <div className="log-detail">
            <span className="label">Username :</span>
            <span className="detail">{username}</span>
          </div>
          <div className="log-detail">
            <span className="label">Branch :</span>
            <span className="detail">{branch}</span>
          </div>
        </div>
      </header>

      {/* Main */}
      <main id="home-container" role="main">
        <section className="card-wrap">
          {/* Card 1 */}
          {showVehicle && (
          <button
            type="button"
            className="card"
            onClick={() => nav("/vehicle_namemaster")}
            style={{ backgroundImage: `url(${VehicleImg})` }}
            aria-label="Vehicle Maintenance"
          >
            <div className="img-overlay" />
            <div className="bottom">
              <h1>Vehicle<br/>Maintenance</h1>
              <p>Track vehicle kilometers, hours, and diesel with auto reminders.</p>
            </div>
          </button>
          )}

          {/* Card 2 */}
          {showInventory && (
          <button
            type="button"
            className="card"
            onClick={() => nav("/inventory/add_Item_Category")}
            style={{ backgroundImage: `url(${InventoryImg})` }}
            aria-label="Purchase & Inventory"
          >
            <div className="img-overlay" />
            <div className="bottom">
              <h1>Purchase &<br/>Inventory</h1>
              <p>Manage purchases and inventory with approvals and analytics.</p>
            </div>
          </button>
          )}

            {!showVehicle && !showInventory && (
            <div className="card" style={{ opacity: 0.7, pointerEvents: "none" }}>
              <div className="bottom">
                <h1>No Modules</h1>
                <p>You don’t have access to Vehicle or Inventory modules.</p>
              </div>
            </div>
          )}

        </section>
      </main>
    </div>
  );
}
